import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { attributesAnalytics } from '../../js/modules/component'

export const HabillageFond = ({ backgroundImage = '', image = '', alt, URL, analytics, cacheKey, display = true }) => {
   const [isVisible, setIsVisible] = useState(display)
   const haloRef = useRef(null)
   const mousePos = useRef({ x: 0, y: 0 })
   const currentPos = useRef({ x: 0, y: 0 })
   const animationFrameId = useRef(null)
   const angle = useRef(0)

   useEffect(() => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

      const handleSG1event = (event) => {
         setIsVisible(event.detail.display)
      }

      window.addEventListener('SG1event-habillage', handleSG1event)

      return () => {
         window.removeEventListener('SG1event-habillage', handleSG1event)
      }
   }, [])

   useEffect(() => {
      const isMobile = document.body.classList.contains('is-mobile')

      const handleMouseMove = (e) => {
         if (!isMobile) {
            mousePos.current = { x: e.clientX - 400, y: e.clientY - 400 }
         }
      }

      if (isMobile) {
         // Mouvement circulaire en mobile
         const circleRadius = 90 // Rayon du cercle de mouvement
         const centerX = window.innerWidth / 2 - 150 // Centre X du cercle (offset de 200px pour le halo)
         const centerY = 100 // Centre Y du cercle (au milieu des 200px)
         const speed = 0.01 // Vitesse de rotation

         const animate = () => {
            // Incrémenter l'angle pour créer le mouvement circulaire
            angle.current += speed

            // Calculer la position sur le cercle
            mousePos.current.x = centerX + Math.cos(angle.current) * circleRadius
            mousePos.current.y = centerY + Math.sin(angle.current) * circleRadius

            // Interpolation pour un mouvement fluide
            const lerp = 0.1
            currentPos.current.x += (mousePos.current.x - currentPos.current.x) * lerp
            currentPos.current.y += (mousePos.current.y - currentPos.current.y) * lerp

            if (haloRef.current) {
               haloRef.current.style.transform = `translate(${currentPos.current.x}px, ${currentPos.current.y}px)`
            }

            animationFrameId.current = requestAnimationFrame(animate)
         }

         animationFrameId.current = requestAnimationFrame(animate)

         return () => {
            if (animationFrameId.current) {
               cancelAnimationFrame(animationFrameId.current)
            }
         }
      } else {
         // Mode desktop : suivi de la souris
         const animate = () => {
            const lerp = 0.01
            currentPos.current.x += (mousePos.current.x - currentPos.current.x) * lerp
            currentPos.current.y += (mousePos.current.y - currentPos.current.y) * lerp

            if (haloRef.current) {
               haloRef.current.style.transform = `translate(${currentPos.current.x}px, ${currentPos.current.y}px)`
            }

            animationFrameId.current = requestAnimationFrame(animate)
         }

         window.addEventListener('mousemove', handleMouseMove)
         animationFrameId.current = requestAnimationFrame(animate)

         return () => {
            window.removeEventListener('mousemove', handleMouseMove)
            if (animationFrameId.current) {
               cancelAnimationFrame(animationFrameId.current)
            }
         }
      }
   }, [])

   return (
      <div class="habillage-fond" key={cacheKey} style={{ display: isVisible ? 'block' : 'none' }}>
         <div class="background-image">
            <img src={backgroundImage} class="background-main-image" alt={alt} />
         </div>
         <div class="halo" ref={haloRef}></div>
         <div class="front-image" style={{ backgroundImage: `url(${image})` }}></div>
         <a class="banner-link" href={URL} {...attributesAnalytics(analytics)}></a>
      </div>
   )
}
